import { render } from "./TermsOfService.vue?vue&type=template&id=7a06c158"
import script from "./TermsOfService.vue?vue&type=script&lang=ts"
export * from "./TermsOfService.vue?vue&type=script&lang=ts"
script.render = render

export default script